import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Style.
 */

const StyledUnfurlSpan = styled.span`
  font-weight: ${fontWeights.bold};
`;

export const DefaultInlineUnfurlWrapper: FC<{children: ReactNode}> = (props) => (
  <StyledUnfurlSpan>{props.children}</StyledUnfurlSpan>
);
